// extracted by mini-css-extract-plugin
export var infoRow = "_rx-2";
export var labelContainer = "_rx-0";
export var rightInfo = "_rx-1";